import angular from 'angular';
import legendBarComponent from './legendBar.component';

let legendBarModule = angular.module('legendBar', []).component('legendBar', legendBarComponent);

export default legendBarModule;



// WEBPACK FOOTER //
// ./app/common/legendBar/legendBar.js